import negotiateConnectionWithClientOffer from './negotiateConnectionWithClientOffer';

export default class WHIPClient {
  private endpoint: string;
  private playElement: HTMLMediaElement;
  private peerConnection: RTCPeerConnection;
  private audioTrack: MediaStreamTrack | null = null;
  private localStream: MediaStream | null = null;

  constructor(endpoint: string, playElement: HTMLMediaElement) {
    this.endpoint = endpoint;
    this.playElement = playElement;
    this.peerConnection = new RTCPeerConnection({
      iceServers: [{ urls: 'stun:stun.cloudflare.com:3478' }],
      bundlePolicy: 'max-bundle',
    });

    this.accessLocalMediaSources()
      .then(stream => {
        this.localStream = stream;
        this.playElement.srcObject = stream;
        this.audioTrack = stream.getAudioTracks()[0] || null;
        if (this.audioTrack) this.audioTrack.enabled = false;
      })
      .catch(console.error);

    this.peerConnection.addEventListener('negotiationneeded', async () => {
      console.log('Negotiation needed - sending offer');
      await negotiateConnectionWithClientOffer(this.peerConnection, this.endpoint);
      console.log('Negotiation complete');
    });
  }

  private async accessLocalMediaSources(): Promise<MediaStream> {
    const stream = await navigator.mediaDevices.getUserMedia({ audio: true, video: false });
    stream.getTracks().forEach(track => {
      this.peerConnection.addTransceiver(track, { direction: 'sendonly' });
    });
    return stream;
  }

  public enableMic(on: boolean): void {
    if (this.audioTrack) {
      this.audioTrack.enabled = on;
      console.log(`Mic ${on ? 'unmuted' : 'muted'}`);
    }
  }

  public disconnectStream(): void {
    if (this.peerConnection.connectionState !== 'closed') {
      fetch(this.endpoint, { method: 'DELETE', keepalive: true });
    }
  
    this.peerConnection.getSenders().forEach(sender => sender.track?.stop());
    this.localStream?.getTracks().forEach(track => track.stop());
  
    this.peerConnection.close();
    this.audioTrack = null;
    this.localStream = null;
  }
}
